// extracted by mini-css-extract-plugin
module.exports = {"memberContainer":"IlluminateMain_memberContainer__6ho4b","logotype":"IlluminateMain_logotype__2Yy0P","packageContainer":"IlluminateMain_packageContainer__1E5cL"};